import { MENU_IDS } from './navigation-menu'

export class VALIDATION_MESSAGE {
  static get SECTION() {
    return {
      [MENU_IDS.TOP_FIVES]: 'You must select at least one answer in each category to complete your digital profile.',
      [MENU_IDS.DID_YOU_KNOW]: 'You must fill out at least one question to complete your digital profile.'
    }
  }

  static get DEFAULT_QUESTION_DESCRIPTION() {
    return 'You must fill out the question to download your PDF.'
  }

  static get QUESTION() {
    return {
      teamMembersSay: {
        title: 'My team members and friends say I am',
        description: 'You must select at least one item to download your PDF.'
      },
      thriveEnv: {
        title: 'I thrive in environments that are',
        description: 'You must select at least one item to download your PDF.'
      },
      selfTag: {
        title: 'Facts about me & my pursuits',
        description: 'You must select at least one item to download your PDF.'
      },
      funFact: {
        title: 'Fun fact about me',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      statNum: {
        title: 'A personal statistic (number)'
      },
      statDetail: {
        title: 'A personal statistic (text)',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      randomJob: {
        title: 'A random job I’d be really good at',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      uniqueInterest: {
        title: 'Unique interests',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      tedTalk: {
        title: 'One day I’ll do a Ted Talk on',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      projectToLife: {
        title: 'If I could bring a project to life, it would be',
        description: 'You must fill out the question with at least 5 characters to download your PDF.'
      },
      hometownLocation: {
        title: 'My hometown is'
      },
      schools: {
        title: 'Schools',
        description: 'You must fill out at least one item to download your PDF.'
      },
      passions: {
        title: 'I pursue with intensity',
        description: 'You must fill out at least one item to download your PDF.'
      },
      expertise: {
        title: 'What expertise do you bring to the table?',
        description: 'You must fill out at least one item to download your PDF.'
      },
      becomeExpertIn: {
        title: 'I want to get better at',
        description: 'You must fill out at least one item to download your PDF.'
      },
      impactOn: {
        title: 'I can create impact on'
      },
      impactInterested: {
        title: `Because I'm interested in`
      },
      impactGoodAt: {
        title: `Because I'm motivated by`
      }
    }
  }
}
